import { render } from "./SessionQuestionBatchPane.vue?vue&type=template&id=22e170da&ts=true"
import script from "./SessionQuestionBatchPane.vue?vue&type=script&lang=ts"
export * from "./SessionQuestionBatchPane.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__